'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('@deskpro/apps-components-style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ActionList = require('./ActionList');

var _ActionList2 = _interopRequireDefault(_ActionList);

var _Layout = require('../Layout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} iconUrl
 * @param {string} title
 * @param {string|Number} badgeText
 * @param children
 * @param {string} className
 * @constructor
 */
var ActionBar = function ActionBar(_ref) {
  var iconUrl = _ref.iconUrl,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-ActionBar dp-Level", className) },
    _react2.default.createElement(
      _Layout.Level,
      { align: "left" },
      iconUrl && _react2.default.createElement(
        'i',
        { className: 'dp-Icon' },
        _react2.default.createElement('img', { src: iconUrl, alt: title })
      ),
      _react2.default.createElement(
        'span',
        { className: 'dp-ActionBarTitle' },
        title
      )
    ),
    _react2.default.createElement(
      _ActionList2.default,
      { className: "dp-LevelRight" },
      children
    )
  );
};

_ActionList2.default.propTypes = {

  className: _propTypes2.default.string,

  iconUrl: _propTypes2.default.string,

  title: _propTypes2.default.string
};

exports.default = ActionBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Action/ActionBar.js
// module id = 335
// module chunks = 0